import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SVGIcon, colors } from '@custom-components';
import { ClickAwayListener, MenuList, Popper, Grow, Paper } from '@mui/material';
import { DropdownButton, DropdownButtonText } from '../TertiaryOptions.styles';
import TertiaryDropdownRoute from './TertiaryDropdownRoute';

function TertiaryDropDown(props) {
  const { icon, label, subMenu, routeName } = props;
  const { defaultMessage: menuLabel = [] } = label;
  const includedRoutes = subMenu.map(({ route }) => route);
  const isSelected = includedRoutes.includes(routeName);
  const displayColor = isSelected ? colors.highlightTheme : colors.colorBlack;

  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const menuId = `${menuLabel}-menu`;

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const menuItems = subMenu.map(({ label: menuItemLabel, route }) => (
    <TertiaryDropdownRoute onClick={handleClose} label={menuItemLabel} route={route} routeName={routeName} />
  ));
  return (
    <>
      <DropdownButton
        btnColor={displayColor}
        isSelected={isSelected}
        ref={(node) => {
          setAnchorEl(node);
        }}
        aria-owns={isOpen ? menuId : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        {icon && <SVGIcon selectedIcon="settings" iconColor={displayColor} />}
        <DropdownButtonText hasIcon={!!icon} color={displayColor}>
          {menuLabel?.[0]?.value}
        </DropdownButtonText>
        <SVGIcon selectedIcon="arrow" height="12px" width="12px" iconColor={displayColor} />
      </DropdownButton>

      <Popper open={isOpen} anchorEl={anchorEl} transition>
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} id={menuId}>
            <Paper elevation={2}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList>{menuItems}</MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

TertiaryDropDown.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.shape({ defaultMessage: PropTypes.string }).isRequired,
  subMenu: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.shape({ defaultMessage: PropTypes.string }),
      route: PropTypes.string,
      routeMatches: PropTypes.arrayOf(PropTypes.string)
    })
  ).isRequired,
  routeName: PropTypes.string.isRequired
};

TertiaryDropDown.defaultProps = {
  icon: ''
};

export default TertiaryDropDown;
